import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { LaundryPriceModel } from '../../models/LaundryPriceModel'

export interface LaundryPriceState {
    LaundryPrice: LaundryPriceModel
    LaundryPriceList: LaundryPriceModel[]
}

const initialState: LaundryPriceState = {
    LaundryPrice: {
        Id: 0,
        PersonTypeId: 0,
        PersonTypeName: '',
        ItemName: '',
        GSTId: 0,
        GSTValue: '',
        WashingPrice: 0,
        DryCleanPrice: 0,
        PressPrice: 0,
    },
    LaundryPriceList: [],
}

export const LaundryPriceSlice = createSlice({
    name: 'laundryPrice',
    initialState,
    reducers: {
        setLaundryPrices: (state, action: PayloadAction<LaundryPriceModel[]>) => {
            state.LaundryPriceList = action.payload
        },
        saveLaundryPrice: (state, action: PayloadAction<LaundryPriceModel>) => {
            let model = action.payload
            if (model.Id > 0) {
                let defaultModel: LaundryPriceModel = {
                    Id: model.Id,
                    PersonTypeId: model.PersonTypeId,
                    PersonTypeName: model.PersonTypeName,
                    ItemName : model.ItemName,
                    GSTId: model.GSTId,
                    GSTValue: model.GSTValue,
                    WashingPrice: model.WashingPrice,
                    DryCleanPrice: model.DryCleanPrice,
                    PressPrice: model.PressPrice
                }
                let currentModel = state.LaundryPriceList.find((c) => c.Id === model.Id) || defaultModel
                currentModel.PersonTypeId = model.PersonTypeId
                currentModel.PersonTypeName = model.PersonTypeName
                currentModel.ItemName = model.ItemName
                currentModel.GSTId = model.GSTId
                currentModel.GSTValue= model.GSTValue
                currentModel.WashingPrice = model.WashingPrice
                currentModel.DryCleanPrice=model.DryCleanPrice
                currentModel.PressPrice = model.PressPrice
            } else {
                model.Id = (Math.max(...state.LaundryPriceList.map((c) => c.Id)) || 0) + 1
                state.LaundryPriceList.push(model)
            }
        },
        getLaundryPriceById: (state, action: PayloadAction<number>) => {
            let id = action.payload
            let model: LaundryPriceModel = initialState.LaundryPrice
            if (id > 0) {
                let currentList: LaundryPriceModel[] = state.LaundryPriceList
                model = currentList.find((c) => c.Id === id) || initialState.LaundryPrice
            }

            state.LaundryPrice = model
        },
        deleteLaundryPrice: (state, action: PayloadAction<string>) => {
            let id: string = action.payload
            let ids: number[] = id.split(',').map((i) => parseInt(i))
            if (ids && ids.length > 0) {
                let currentList: LaundryPriceModel[] = state.LaundryPriceList
                state.LaundryPriceList = currentList.filter((c) => !ids.includes(c.Id))
            }
        },
    },
})

export const { setLaundryPrices, saveLaundryPrice, getLaundryPriceById, deleteLaundryPrice } =
LaundryPriceSlice.actions

export default LaundryPriceSlice.reducer
